import { getRum } from './rumClient';

export const logInfo = (
  actionName: string,
  source: string,
  message: string,
  status?: number | string,
  additionalContext?: Record<string, any>
) => {
  getRum()?.recordEvent(actionName, {
    source,
    message,
    ...(status !== undefined && { status }),
    ...additionalContext,
  });
};

export const logError = (
  error: Error | string,
  source: string,
  additionalContext?: Record<string, any>
) => {
  const errorObj = typeof error === 'string' ? new Error(error) : error;
  getRum()?.recordError(errorObj);
};

export const logChatNavigation = (
  sender: any,
  receiver: any,
  job: any,
  channel: any,
  additionalContext?: Record<string, any>
) => {
  getRum()?.recordEvent('chat_navigation', {
    sender_id: sender?.external_user_id,
    sender_role: sender?.role,
    sender_name: `${sender?.first_name} ${sender?.last_name}`,
    receiver_id: receiver?.external_user_id,
    receiver_name: `${receiver?.first_name} ${receiver?.last_name}`,
    receiver_role: receiver?.role,
    job_id: job?.job_id,
    candidate_id: job?.candidate_id,
    channel_arn: channel?.channelArn,
    channel_name: channel?.channelName,
    ...additionalContext,
  });
};

export const logMessageSent = (
  sender: string,
  receiver: string,
  channel: any,
  messageType: string = 'text',
  additionalContext?: Record<string, any>
) => {
  console.log('loggingg message sent');
  getRum()?.recordEvent('message_sent', {
    sender_id: sender,
    receiver_id: receiver,
    channel_arn: channel,
    message_type: messageType,
    ...additionalContext,
  });
};
